import React from "react";
import { MenuItem, Select, FormControl, Box, Typography } from "@mui/material";
import { uploadAttachmentsOptions } from "../../../../lead-filter/lead-filter.constant";
import { dropDownProps } from "./lead-view-details-view-attachment-info.props";

const UploadDropDown : React.FC<dropDownProps>  = ({
    selectedOption,
    handleChange,
    disableEdit=false,
}) => {
    return (
      <FormControl fullWidth className="upload-dropdown">
        <Select
          displayEmpty
          value={selectedOption}
          onChange={handleChange}
          renderValue={(selectedVal) => {
            if (!selectedVal) {
              return <span className="placeholder">Attach</span>;
            }
            const selected = uploadAttachmentsOptions.find(
              (opt) => opt.value === selectedVal
            );
            return selected?.label || "";
          }}
          disabled={disableEdit}
          sx={{
            "&.Mui-disabled": {
              cursor: "not-allowed",
            },
            "& .MuiSelect-select.Mui-disabled": {
              cursor: "not-allowed",
            },
          }}
          className={disableEdit ? "disabled-select" : ""}
        >
          {uploadAttachmentsOptions?.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <img
                  src={option.icon}
                  alt={option.label}
                  className="upload-icon"
                />
                <Typography className="option-text">{option.label}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
};

export default UploadDropDown;
